import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LoadingScreen from "./components/LoadingScreen";
import CustomCursor from './components/CustomCursor';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LetsWorkSection from "./components/LetsWorkSection";
import WhatsAppButton from "./components/WhatsAppButton";

import Homme from "./pages/Homme";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import Showcase from "./pages/Showcase";
import ProjectDetails from "./pages/ProjectDetails";

import "./App.scss";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <CustomCursor />
          <Navbar />
          <Routes>
            <Route path="/" element={<Homme />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/Showcase" element={<Showcase />} />
            <Route path="/ProjectDetails/:id" element={<ProjectDetails />} />
          </Routes>
          <WhatsAppButton />
          <LetsWorkSection />
          <Footer />
        </>
      )}
    </Router>
  );
};

export default App;
